import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  position: absolute;
  background-color: #fff;
  height: 100%;
  width: 100%;
  z-index: 2;
  top: 0;
  left: 0;
  display: flex;
`;

export const CloseButton = styled.div`
  position: absolute;
  font-size: 1.4em;
  top: 6px;
  right: 15px;
  cursor: pointer;

  svg {
    transition: 0.1s ease-in-out;
  }

  &:hover {
    svg {
      color: #79D9D9;
    }
  }

  ${mediaMaxWidth.phone`
    background-color: #fff;
    top: 0;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 5px;
  `}
`;

export const ImagesWrapper = styled.div`
  display: flex;
  position: relative;
  overflow: hidden;
  width: 170px;
  justify-content: center;
  align-items: center;
  margin: 10px auto 0 auto;
`;

export const ImagePlaceholder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e4e5e7;
  border-radius: 4px;
  width: 170px;
  height: 170px;

  svg {
    font-size: 2em;
    color: #fff;
  }
`;

export const Image = styled.img`
  width: 170px;
  height: 170px;
  object-fit: cover;
  border-radius: 4px;
`;

export const Preview = styled.div`
  position: absolute;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  width: 170px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8em;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  text-transform: capitalize;
`;

export const PrevButton = styled.div`
  position: absolute;
  left: 60px;
  top: 70px;
  font-size: 2em;
  cursor: pointer;

  &:hover {
    color: #79D9D9;
  }
`;

export const NextButton = styled.div`
  position: absolute;
  right: 60px;
  top: 70px;
  font-size: 2em;
  cursor: pointer;

  &:hover {
    color: #79D9D9;
  }
`;

export const Form = styled.form`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-content: flex-start;
  padding: 10px 0;
  justify-content: center;
  align-items: center;
  height: 80px;
`;

export const UploadInputWrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: inline-block;
`;

export const UploadInput = styled.input`
  font-size: 100px;
  position: absolute;
  left: -32px;
  top: 0;
  opacity: 0;
  height: 23px;
  width: 140px;
  cursor: pointer;
`;

export const UploadButton = styled.button`
  border: none;
  color: #333;
  text-transform: capitalize;
  background-color: unset;
  font-weight: bold;
`;

export const Action = styled.div`
  background-color: #e4e5e7;
  width: max-content;
  color: #333;
  border-radius: 4px;
  padding: 3px 10px;
  margin-bottom: ${(props) => props.upload && "10px"};
  font-weight: 700;
  font-size: 0.9em;
  cursor: pointer;
  align-items: center;
  text-transform: capitalize;
  height: 26px;
  display: flex;

  svg {
    margin-right: 10px;
  }

  &:hover {
    background-color: ${(props) => props.upload && "#27ae60"};
    background-color: ${(props) => props.delete && "#f84c4c"};
    color: #fff;

    button {
      color: #fff;
    }
  }

  ${mediaMaxWidth.phone`
    height: 35px;
    padding: 5px 15px;
    margin-bottom: ${(props) => props.upload && "20px"};
  `}
`;

export const SaveButton = styled.button`
  position: absolute;
  bottom: 10px;
  right: 10px;
  font-weight: bold;
  color: #fff !important;
  padding: 5px 25px;
  cursor: pointer;
  background: #79D9D9;
  border: 1px solid #79D9D9;
  text-transform: capitalize;
  box-sizing: border-box;
  border-radius: 4px;
  -webkit-transition: 0.15s ease-in-out;
  transition: 0.15s ease-in-out;
  width: 85px;

  &:focus {
    outline: none;
  }

  &:hover {
    background: #79D9D9;
  }
`;

export const FileSizeError = styled.div`
  font-size: 12px;
  color: #ff0000;
  position: absolute;
  margin-top: 22px;
`;
